import { render, staticRenderFns } from "./PollCounter.vue?vue&type=template&id=2c673e5c&"
import script from "./PollCounter.vue?vue&type=script&lang=js&"
export * from "./PollCounter.vue?vue&type=script&lang=js&"
import style0 from "./PollCounter.vue?vue&type=style&index=0&id=2c673e5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports